/**
 * 탭이 숨었는지. 폴링 · 서버 재대조는 숨은 탭에서 묻지 않고, 다시 보일 때 묻는다.
 *
 * `document` 가 없는 환경(node 테스트)은 보이는 것으로 본다.
 */
export function isPageHidden(): boolean {
  return typeof document !== "undefined" && document.visibilityState === "hidden";
}
